/**
 * TODO: DEPRECATE
 * replaced by support-home.component
 */
angular
    .module("app")
    .controller("SupportController", function(
        $scope,
        $localStorage,
        $browser,
        $window,
        $timeout,
        $location,
        toastr,
        ModalService,
        $uibModal,
        UserDetails,
        DynamicMenuServiceApi,
        SettingsService
    ) {
        var vm = this;
        $window.vm = vm;
        vm.state = {
            userDetails: null
        };
        vm.data = {};
        vm.uploads = uploads;

        vm.navigate = navigate;

        this.$onInit=function(){
            init();
        };
        var init = function() {

            SettingsService.getSettings().then(function (response) {
                var appSettings = response.data;
                vm.state.appSettings = appSettings;
                // console.info(appSettings);
            });

            UserDetails.get().then(
                function(data) {
                    // Get our user details
                    vm.state.userDetails = data; // setup our user details
                },
                function() {
                    toastr.error(
                        "Please make sure that you are logged in to OTS UTP!"
                    );
                    $window.location.href =
                        $browser.baseHref() + "account/login";
                    return;
                }
            );

            DynamicMenuServiceApi.navItems().then(function(response) {
                var menuItems = response.data;
                vm.menuItems = menuItems;
                /*
                    NOTE: The menuItems are trimmed on the server for the Admin and Support Roles
                    NOTE: The Uploads menu item and link list items
                          are inserted manually at the end of the list generated from menuItems
                          Support gets Uploads if web.config UploadModule flag is true
                    */
            });
        };

        function navigate(url) {
            $window.location.href = $browser.baseHref() + url;
        }

        // SVG stuff
        vm.Pass = 50;
        vm.Fail = 20;
        vm.Untested = 20;
        vm.NumTests = vm.Pass + vm.Fail + vm.Untested;

        vm.show = function(label) {           
            vm.label = label;
        };

        function uploads() {
            $location.path("/Uploads/AspNetUsers/" + vm.state.userDetails.Id);
        }
    });
